import React from "react";
import "./App.css";
import { Toaster } from 'sonner';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { HighlightsSection } from './components/HighlightsSection';
import { BandMembersSection } from './components/BandMembersSection';
import { MediaGallery } from './components/MediaGallery';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import Testimonials from "./components/Testimonials";

function App() {
  return (
    <div className="App bg-black">
      <Toaster richColors closeButton />
      <Header />
      <main id="home">
        <HeroSection />
        <AboutSection />
        <HighlightsSection />
        {/* <BandMembersSection /> */}
        <MediaGallery />
        <Testimonials />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
